import { observable, computed, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import {calendarDate} from 'shared/tools';
import moment from 'moment';

class Dependent extends DomainObject {
  benefitInfoId;
  firstName;
  lastName;
  student = false;
  gender;
  disabledAdult = false;
  birthDate;
  _destroy = false;
  institutionName;
  educationStartDate;
  expectedGraduationDate;
  eligible;

  _relations = {
    _dates: ['birthDate', 'educationStartDate', 'expectedGraduationDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      benefitInfoId: observable,
      firstName: observable,
      lastName: observable,
      student: observable,
      gender: observable,
      disabledAdult: observable,
      birthDate: observable,
      _destroy: observable,
      institutionName: observable,
      educationStartDate: observable,
      expectedGraduationDate: observable,
      eligible: observable,
      birthDateView: computed,
      educationStartDateView: computed,
      expectedGraduationDateView: computed
    });

    this.merge(other);
  }

  get birthDateView() {
    return calendarDate(this.birthDate);
  }

  get educationStartDateView() {
    return moment(this.educationStartDate).format('MMM YYYY');
  }

  get expectedGraduationDateView() {
    return moment(this.expectedGraduationDate).format('MMM YYYY');
  }
}

export default Dependent;
